"use strict";
/**
 * Formata números em R$.
 *
 * @param {number} value Valor em Number
 * @return R$ X.XXX
 * @example formatToCurrency(1234) => 'R$ 1.234,00'
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToSelect = exports.formatToNumber = exports.formatToCurrency = void 0;
var formatToCurrency = function (value) {
    return Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
};
exports.formatToCurrency = formatToCurrency;
/**
 * Formata os números de acordo com o padrão brasileiro
 * @param {number} value Valor a ser formatado
 * @returns {number}
 * @example formatToCurrency(1234) => '1.234'
 */
var formatToNumber = function (value) {
    return value.toLocaleString('pt-BR');
};
exports.formatToNumber = formatToNumber;
/**
 * Formata um array de  dados para o padrão necessário para  o select
 * @param array Array de dados
 * @param code chave para o valor code
 * @param description chave para o valor description
 * @param label *Opcional* chave para o valor label
 * @param value *Opcional* chave para o valor value
 * @returns
 */
function transformToSelect(array, code, description, label, value) {
    return array.map(function (item) { return ({
        // @ts-ignore
        code: item[code],
        // @ts-ignore
        description: item[description],
        // @ts-ignore
        label: label ? item[label] : item[description],
        // @ts-ignore
        value: value ? item[value] : item[code],
    }); });
}
exports.transformToSelect = transformToSelect;
//# sourceMappingURL=formatValue.js.map